
const digest = 'c6b0f6f4cf1adc9a2618705fd7131dd46fd358a1230325baeade8230d88c6a22';
const classes = {"wrapper":"_wrapper_3lgcr_1","employer":"_employer_3lgcr_7","bigText":"_bigText_3lgcr_12","smallText":"_smallText_3lgcr_16","inline":"_inline_3lgcr_19","addressLike":"_addressLike_3lgcr_25","smallerText":"_smallerText_3lgcr_31","addressText":"_addressText_3lgcr_34","insuranceBlock":"_insuranceBlock_3lgcr_39"};
const css = `._wrapper_3lgcr_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_3lgcr_1 ._employer_3lgcr_7 {
  display: flex;
  gap: 5px;
  align-items: center;
}
._wrapper_3lgcr_1 ._bigText_3lgcr_12 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_3lgcr_1 ._smallText_3lgcr_16 {
  font-size: 12px;
}
._wrapper_3lgcr_1 ._inline_3lgcr_19 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
}
._wrapper_3lgcr_1 ._addressLike_3lgcr_25 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
}
._wrapper_3lgcr_1 ._smallerText_3lgcr_31 {
  font-size: 12px;
}
._wrapper_3lgcr_1 ._addressText_3lgcr_34 {
  font-size: 14px;
  font-weight: 500;
}

._insuranceBlock_3lgcr_39 {
  margin-bottom: 16px;
  max-width: 50%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  